var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYelowLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.25V7.125C16.5 9.8175 14.3175 12 11.625 12H9.75V15.75H8.25V10.5L8.26425 9.75C8.4555 7.233 10.5593 5.25 13.125 5.25H16.5ZM4.5 2.25C6.819 2.25 8.787 3.75375 9.48225 5.8395C8.35725 6.79575 7.61475 8.1855 7.512 9.75H6.75C3.8505 9.75 1.5 7.3995 1.5 4.5V2.25H4.5Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelowLeaf);
export default __webpack_public_path__ + "static/media/yelowLeaf.2d25ddc5b5988e59d9d1871db3a7fed1.svg";
export { ForwardRef as ReactComponent };